import React, { useState } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Box,
  Typography,
} from "@mui/material";
import GlobalButton from "../../../shared/utils/GlobalButton";

const PDIRejectedDialog = ({
  open,
  onClose,
  onSubmit,
  isProcessing = false,
  multiline = false,
  rows = 4,
  labelText = "Rejection Reason:",
  rejectButtonText = "Reject",
}) => {
  const [rejectionReason, setRejectionReason] = useState("");

  const handleSubmit = async () => {
    if (!rejectionReason.trim()) return;
    await onSubmit(rejectionReason);
    setRejectionReason("");
  };
  const handleCancel = () => {
    if (isProcessing) return;
    setRejectionReason("");
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={handleCancel}
      disableEscapeKeyDown={isProcessing}
      PaperProps={{
        sx: {
          borderRadius: 2,
          minWidth: 400,
        },
      }}
    >
      <DialogTitle sx={{ pb: 1 }}>
        <Typography variant="h6" component="span">
          Reject Job
        </Typography>
      </DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="textSecondary" gutterBottom>
          {labelText}
        </Typography>
        <TextField
          autoFocus
          margin="dense"
          placeholder="Enter reason for rejection"
          type="text"
          fullWidth
          multiline={multiline}
          rows={rows}
          value={rejectionReason}
          onChange={(e) => setRejectionReason(e.target.value)}
          disabled={isProcessing}
          variant="outlined"
          size="small"
          sx={{ mt: 1 }}
        />
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <GlobalButton
          onClick={handleCancel}
          variant="secondary"
          disabled={isProcessing}
        >
          {`Close`}
        </GlobalButton>
        <GlobalButton
          variant="warning"
          onClick={handleSubmit}
          disabled={!rejectionReason.trim() || isProcessing}
          isLoading={isProcessing}
        >
          {rejectButtonText}
        </GlobalButton>
      </DialogActions>
    </Dialog>
  );
};

export default PDIRejectedDialog;
